import { render, staticRenderFns } from "./firm-detail-view.vue?vue&type=template&id=72ac20d3&scoped=true&"
import script from "./firm-detail-view.vue?vue&type=script&lang=js&"
export * from "./firm-detail-view.vue?vue&type=script&lang=js&"
import style0 from "./firm-detail-view.vue?vue&type=style&index=0&id=72ac20d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ac20d3",
  null
  
)

export default component.exports